// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__y3mx8","closeButton":"styles_closeButton__XG8om","title":"styles_title__dHums","container":"styles_container__yDyla"};